import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { NavTab, NavTabItem, ButtonGroup } from '@cimpress/react-components';

import { FULFILLERS, MERCHANTS } from '../../constants/transactorType';
import { selectors as identitySelectors } from '../../reducers/identities';
import { typeIsFulfiller, typeIsMerchant } from '../../reducers/identities/utils';
import BasicLayout from '../layouts/BasicLayout';
import Button from '../common/Button';
import ApprovalSettings from './approvals/ApprovalSettings';
import SubscriptionSettings from './subscriptions/SubscriptionSettings';
import { CONTRACT_NOTIFICATION, PRODUCT_NOTIFICATION } from '../../constants/subscriptionConstants';
import { extractV2KeyInfo, productAgreementUrl } from '../../utilities/productAgreementHelper';

const CONTRACT_SUBSCRIPTIONS_TAB = 'CONTRACT_SUBSCRIPTIONS';
const PRODUCT_SUBSCRIPTIONS_TAB = 'PRODUCT_SUBSCRIPTIONS';
const AUTOAPPROVALS_TAB = 'AUTOAPPROVALS';

class SettingsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // if one has access to both identities, the default selection is fulfillers
      identityType: this.props.hasFulfillers ? FULFILLERS : MERCHANTS,
      identityId: undefined,
      selectedTab: CONTRACT_SUBSCRIPTIONS_TAB
    };
  }

  onFulfillerSelected = () => {
    this.setState({ identityType: FULFILLERS });
  };

  onMerchantSelected = () => {
    this.setState({ identityType: MERCHANTS });
  };

  onSelectIdentity = selection => {
    this.setState({ identityId: selection && (selection.value || selection.id) });
  };

  isV2Info = v2Info => {
    return v2Info.businessIds && v2Info.businessIds !== 'undefined';
  };

  onContractSubscriptionsSelect = (e, v2Info) => {
    if (!this.isV2Info(v2Info)) {
      this.setState({ selectedTab: CONTRACT_SUBSCRIPTIONS_TAB });
    }
  };

  onProductSubscriptionsSelect = (e, v2Info) => {
    if (!this.isV2Info(v2Info)) {
      this.setState({ selectedTab: PRODUCT_SUBSCRIPTIONS_TAB });
    }
  };

  onAutoApprovalsSelect = () => {
    this.setState({ selectedTab: AUTOAPPROVALS_TAB });
  };

  render() {
    const { t, hasFulfillers, hasMerchants } = this.props;
    const { identityId, identityType, selectedTab } = this.state;

    const v2Key = this.props.match.params.v2Key;
    const v2Info = extractV2KeyInfo(v2Key);

    const defaultSelectedTab = this.isV2Info(v2Info) ? AUTOAPPROVALS_TAB : selectedTab;

    const identityButtonGroup = hasFulfillers &&
      hasMerchants &&
      (defaultSelectedTab === CONTRACT_SUBSCRIPTIONS_TAB || defaultSelectedTab === AUTOAPPROVALS_TAB) && (
        <div className={'settings__identity-button'}>
          <h5>{`${t('settings:subscriptions.manageSettingsFor')}:`}</h5>
          <ButtonGroup type="justified">
            <Button
              className={`settings__button-group btn btn-default ${typeIsFulfiller(identityType) ? 'active' : ''}`}
              onClick={this.onFulfillerSelected}>
              {t('common:commonTerminology.seller_plural')}
            </Button>
            <Button
              className={`settings__button-group btn btn-default ${typeIsMerchant(identityType) ? 'active' : ''}`}
              onClick={this.onMerchantSelected}
              disabled={this.isV2Info(v2Info)}>
              {t('common:commonTerminology.buyer_plural')}
            </Button>
          </ButtonGroup>
        </div>
      );

    let tabContent;
    switch (defaultSelectedTab) {
      case CONTRACT_SUBSCRIPTIONS_TAB:
        tabContent = (
          <SubscriptionSettings
            identityType={identityType}
            onFulfillerSelected={this.onFulfillerSelected}
            onMerchantSelected={this.onMerchantSelected}
            notificationType={CONTRACT_NOTIFICATION}
          />
        );
        break;
      case PRODUCT_SUBSCRIPTIONS_TAB:
        tabContent = (
          <SubscriptionSettings
            identityType={MERCHANTS}
            onFulfillerSelected={this.onFulfillerSelected}
            onMerchantSelected={this.onMerchantSelected}
            notificationType={PRODUCT_NOTIFICATION}
          />
        );
        break;
      case AUTOAPPROVALS_TAB:
        tabContent = (
          <ApprovalSettings
            identityId={identityId}
            identityType={identityType}
            onFulfillerSelected={this.onFulfillerSelected}
            onMerchantSelected={this.onMerchantSelected}
            onSelectIdentity={this.onSelectIdentity}
          />
        );
        break;
      default:
        break;
    }

    return (
      <div>
        <div style={{ paddingLeft: '20px' }}>
          {this.isV2Info(v2Info) ? <a href={productAgreementUrl(v2Info)}>Back to Product Agreements</a> : null}
        </div>
        <BasicLayout className="settings">
          <h1 style={{ marginLeft: 15, marginBottom: 25 }}>{t('settings:header')}</h1>
          <div className="navtab-container">
            <NavTab>
              <NavTabItem active={defaultSelectedTab === CONTRACT_SUBSCRIPTIONS_TAB} disabled={this.isV2Info(v2Info)}>
                <Button onClick={e => this.onContractSubscriptionsSelect(e, v2Info)}>
                  {t('settings:subscriptions.header', { context: CONTRACT_NOTIFICATION })}
                </Button>
              </NavTabItem>
              <NavTabItem active={defaultSelectedTab === PRODUCT_SUBSCRIPTIONS_TAB} disabled={this.isV2Info(v2Info)}>
                <Button onClick={e => this.onProductSubscriptionsSelect(e, v2Info)}>
                  {t('settings:subscriptions.header', { context: PRODUCT_NOTIFICATION })}
                </Button>
              </NavTabItem>
              <NavTabItem active={defaultSelectedTab === AUTOAPPROVALS_TAB}>
                <Button onClick={this.onAutoApprovalsSelect}>{t('settings:autoApprovals.header')}</Button>
              </NavTabItem>
            </NavTab>
          </div>
          <hr />
          {identityButtonGroup}
          <div style={{ marginLeft: 10 }}>{tabContent}</div>
        </BasicLayout>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasFulfillers: identitySelectors.getHasFulfillerIdentities(state),
  hasMerchants: identitySelectors.getHasMerchantIdentities(state)
});

export default connect(mapStateToProps)(withTranslation()(SettingsPage));
